/**
 * Sleep for some milliseconds
 * @param ms 毫秒
 */
export function delay(ms) {
    if (ms === void 0) { ms = 1000; }
    return new Promise(function (resolve) { return setTimeout(resolve, ms); });
}
